import { useAtomValue } from 'jotai';
import type React from 'react';
import { Link } from 'react-router';

import { userIsInternalAtom } from '@/store/user.store';
import { extractCaseId, parseCaseIdsToLinks } from '@/utils/Common.utils';
export const CaseIdLink = ({
  href,
  children
}: {
  href?: string;
  children?: React.ReactNode;
}) => {
  const userIsInternal = useAtomValue(userIsInternalAtom);

  // Handle Markdown link usage (when href is provided)
  if (href) {
    const caseId = extractCaseId(href);
    if (!caseId) {
      return <span>{children}</span>;
    }
    const caseLink = userIsInternal
      ? `/case-internal/${caseId}`
      : `/case/${caseId}`;

    return href.includes('.pondurance.com/case/') ? (
      <Link to={caseLink}>{caseId}</Link>
    ) : (
      <span>{children}</span>
    );
  }

  // Handle wrapper usage (parse text content for case IDs)
  if (typeof children !== 'string') {
    return <>{children}</>;
  }

  const parts = parseCaseIdsToLinks(children);

  return (
    <>
      {parts.map((part, index) => {
        if (part.includes('.pondurance.com/case/')) {
          const caseId = extractCaseId(part);
          const caseLink = userIsInternal
            ? `/case-internal/${caseId}`
            : `/case/${caseId}`;
          return caseId ? (
            // biome-ignore lint/suspicious/noArrayIndexKey: parts come from splitting a string; no stable id exists and the list is static per render
            <Link key={`${part}-${index}`} to={caseLink}>
              {caseId}
            </Link>
          ) : (
            // biome-ignore lint/suspicious/noArrayIndexKey: parts come from splitting a string; no stable id exists and the list is static per render
            <span key={`${part}-${index}`}>{part}</span>
          );
        }
        // biome-ignore lint/suspicious/noArrayIndexKey: parts come from splitting a string; no stable id exists and the list is static per render
        return <span key={`${part}-${index}`}>{part}</span>;
      })}
    </>
  );
};

export default CaseIdLink;
